// Portado de src/pages/sobre.astro (site Astro).
import { MEDICO } from "@/lib/itv/site";
import { useAgendamentoLink } from "@/lib/itv/agendamento";
import { CardsAtendimento } from "@/components/itv/CardsAtendimento";
import entrevistaCarnavalAsset from "@/assets/midia/entrevista-carnaval-tv-tem.jpg.asset.json";
import logoBoaFormaAsset from "@/assets/midia/logo-boa-forma.svg.asset.json";
import logoTerraAsset from "@/assets/midia/logo-terra.svg.asset.json";
import logoMetropolesAsset from "@/assets/midia/logo-metropoles.jpg.asset.json";
import logoInfoMoneyAsset from "@/assets/midia/logo-infomoney.png.asset.json";

// hero-cinema → stats (Figma 130:22).
// Nota do cliente: os itens "NOTA EM 204 AVALIAÇÕES" (avaliação do Google) foram
// omitidos por regra do cliente (nunca publicar nota/número de avaliações do Google).
const stats = [
  { numero: "03", rotulo: "ESPECIALIDADES RQE" },
  { numero: "200 MIL+", rotulo: "NO YOUTUBE E INSTAGRAM" },
  { numero: "400+", rotulo: "VÍDEOS PUBLICADOS" },
];

// trajetoria (Figma 130:35).
// Nota do cliente: o marco "EINSTEIN" (Hospital Israelita Albert Einstein) foi
// omitido por não constar na lista oficial de credenciais.
const marcos = [
  {
    sigla: "UNIFESP",
    titulo: "Medicina pela Escola Paulista de Medicina",
    texto: "Formado em 2010 pela UNIFESP-EPM, uma das escolas médicas mais concorridas do país.",
  },
  {
    sigla: "TRÊS RQES",
    titulo: "Nutrologia, Medicina do Esporte e Ortopedia",
    texto: "Três especialidades registradas no CRM:",
  },
  {
    sigla: "EBOM · PABOM",
    titulo: "Títulos internacionais em medicina da obesidade",
    texto: "Membro dos boards europeu e pan-americano.",
  },
  {
    sigla: "ITV",
    titulo: "O consultório próprio em Bauru",
    texto:
      "Instituto Dr. Thiago Viana: presencial e teleconsulta para todo o Brasil, sempre com o mesmo médico.",
  },
  {
    sigla: "MÉTODO SP",
    titulo: "Saúde com Propósito",
    texto: "A forma de cuidar que ele criou: sete pilares integrados, do metabolismo ao propósito de vida.",
  },
  {
    sigla: "HOJE",
    titulo: "Pós-graduando em Medicina Regenerativa",
    texto: "Ampliando a frente de estética e regeneração.",
  },
];

// registros-e-sociedades (Figma 141:9). RQEs e CRM saem de @/lib/itv/site.
const registros = [
  {
    grupo: "FORMAÇÃO",
    linhas: [
      {
        sigla: "UNIFESP-EPM",
        texto: `Medicina pela Universidade Federal de São Paulo, Escola Paulista de Medicina, 2010 · ${MEDICO.crm}`,
      },
      { sigla: "MEDICINA REGENERATIVA", texto: "Pós-graduação em Medicina Regenerativa" },
    ],
  },
  {
    grupo: "TÍTULOS DE ESPECIALISTA",
    linhas: [
      { sigla: "NUTROLOGIA", texto: `Título de Especialista em Nutrologia · ${MEDICO.especialidades[0].rqe}` },
      {
        sigla: "MED. DO ESPORTE",
        texto: `Título de Especialista em Medicina do Esporte · ${MEDICO.especialidades[1].rqe}`,
      },
      {
        sigla: "ORTOPEDIA",
        texto: `Título de Especialista em Ortopedia e Traumatologia · ${MEDICO.especialidades[2].rqe}`,
      },
    ],
  },
  {
    grupo: "SOCIEDADES E BOARDS",
    linhas: [
      { sigla: "ABRAN", texto: "Associação Brasileira de Nutrologia" },
      { sigla: "SBMEE", texto: "Sociedade Brasileira de Medicina do Exercício e do Esporte" },
      { sigla: "SBEMO", texto: "Sociedade Brasileira de Medicina da Obesidade" },
      { sigla: "EBOM", texto: "European Board of Obesity Medicine" },
      { sigla: "PABOM", texto: "Pan American Board of Obesity Medicine" },
      { sigla: "SBOT", texto: "Sociedade Brasileira de Ortopedia e Traumatologia" },
      { sigla: "SBCOC", texto: "Sociedade Brasileira de Cirurgia de Ombro e Cotovelo" },
    ],
  },
];

const materias = [
  {
    veiculo: "BOA FORMA",
    logo: logoBoaFormaAsset.url,
    titulo: "Por que emagrecer com saúde não significa apenas perder peso?",
    url: "https://boaforma.abril.com.br/equilibrio/por-que-emagrecer-com-saude-nao-significa-apenas-perder-peso/",
  },
  {
    veiculo: "BOA FORMA",
    logo: logoBoaFormaAsset.url,
    titulo: "Descubra como a atividade física influencia seu intestino: mitos e verdades",
    url: "https://boaforma.abril.com.br/movimento/mito-x-verdade-praticar-atividade-fisica-pode-ajudar-no-funcionamento-do-intestino",
  },
  {
    veiculo: "TERRA",
    logo: logoTerraAsset.url,
    titulo: "Emagrecer com saúde exige mais do que perder peso: veja dicas práticas",
    url: "https://www.terra.com.br/vida-e-estilo/saude/emagrecer-com-saude-exige-mais-do-que-perder-peso-veja-dicas-praticas,00d03bafbd4a3fd5da26afdf7bf025007qelnm8g.html",
  },
  {
    veiculo: "TERRA",
    logo: logoTerraAsset.url,
    titulo: "Quer emagrecer após os 40? Entenda por que só força de vontade não basta",
    url: "https://www.terra.com.br/vida-e-estilo/saude/quer-emagrecer-apos-os-40-entenda-por-que-so-forca-de-vontade-nao-basta,cc2e6c57bb00be142583e038c8b72a2crk2soy6x.html",
  },
  {
    veiculo: "TERRA",
    logo: logoTerraAsset.url,
    titulo: "Bactérias que emagrecem: como o intestino pode influenciar na perda de peso",
    url: "https://www.terra.com.br/vida-e-estilo/degusta/alimentacao-com-saude/bacterias-que-emagrecem-como-o-intestino-pode-influenciar-na-perda-de-peso,a864758112b92beae20be7a430004305ablz7r7g.html",
  },
  {
    veiculo: "TERRA",
    logo: logoTerraAsset.url,
    titulo: "Emagreceu? Saiba o que fazer para evitar o reganho de peso",
    url: "https://www.terra.com.br/vida-e-estilo/emagreceu-saiba-o-que-fazer-para-evitar-o-reganho-de-peso,cdaff54d2ee0b3f4b6999afe7a8a1153ot4wiqnb.html",
  },
  {
    veiculo: "METRÓPOLES",
    logo: logoMetropolesAsset.url,
    titulo: "Emagrecer após os 40 não depende só de força de vontade. Entenda",
    url: "https://www.metropoles.com/saude/emagrecer-aos-40-nao-depende-de-forca-de-vontade",
  },
  {
    veiculo: "METRÓPOLES",
    logo: logoMetropolesAsset.url,
    titulo: "O que acontece com o corpo quando você toma chá todos os dias",
    url: "https://www.metropoles.com/colunas/claudia-meireles/o-que-acontece-com-o-corpo-quando-voce-toma-cha-todos-os-dias",
  },
  {
    veiculo: "INFOMONEY",
    logo: logoInfoMoneyAsset.url,
    titulo: "Quais devem ser os cuidados com a alimentação durante as festas de final de ano?",
    url: "https://www.infomoney.com.br/saude/quais-devem-ser-os-principais-cuidados-com-a-alimentacao-nas-festas-de-final-de-ano/",
  },
];

const participacoesEmVideo = [
  {
    veiculo: "TV TEM · GLOBOPLAY",
    titulo: "Cuidados com alimentação e hidratação durante o Carnaval",
    url: "https://globoplay.globo.com/v/13377897/",
    imagem: entrevistaCarnavalAsset.url,
    alt: "Dr. Thiago Viana em entrevista à TV TEM",
    link: "Assistir no Globoplay →",
  },
];

export function Sobre() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-sobre">
      {/* hero-cinema — Figma 130:14 */}
      <section className="hero">
        <div className="hero-fundo">
          <img
            src="/img/sobre-hero-1440.webp"
            srcSet="/img/sobre-hero-640.webp 640w, /img/sobre-hero-960.webp 960w, /img/sobre-hero-1440.webp 1440w"
            sizes="100vw"
            alt="Dr. Thiago Viana, nutrólogo e médico do esporte"
            width={1440}
            height={2158}
            loading="eager"
            fetchPriority="high"
          />
          <span className="hero-veu" aria-hidden="true" />
        </div>

        <div className="container hero-conteudo">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span> <span>Sobre</span>
          </nav>
          <p className="hero-sobretitulo">O MÉDICO POR TRÁS DO MÉTODO</p>
          <h1>Dr. Thiago Viana.</h1>
          <p className="hero-chamada">
            Três especialidades, um método próprio e uma convicção: saúde é ferramenta{" "}
            <em>para viver o propósito</em>.
          </p>
          <a className="btn-ouro hero-btn" href={agendar}>
            Agendar consulta
          </a>
        </div>

        <ul className="hero-stats">
          {stats.map((s) => (
            <li key={s.rotulo}>
              <span className="stat-numero">{s.numero}</span>
              <span className="stat-rotulo">{s.rotulo}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* quem-e — Figma 141:2 */}
      <section className="quem-e">
        <div className="container quem-e-grade">
          <div className="quem-e-statement">
            <p className="sobretitulo">QUEM É</p>
            <h2>Conheça mais sobre o Dr Thiago Viana</h2>
          </div>
          <div className="quem-e-colunas">
            <p>
              O Dr. Thiago Viana é médico formado pela Universidade Federal de São Paulo, a Escola
              Paulista de Medicina, em 2010. Construiu uma combinação rara na medicina brasileira: três
              títulos de especialista registrados, em Nutrologia, Medicina do Esporte e Ortopedia e
              Traumatologia. É esse conjunto que permite avaliar metabolismo, treino e articulação na
              mesma consulta, do primeiro exame ao acompanhamento.
            </p>
            <p>
              Da prática no consultório nasceu o Método SP, Saúde com Propósito, que integra saúde
              física, mental e espiritual na busca por saúde e longevidade. Fora do consultório,
              participa de entrevistas e reportagens sobre emagrecimento, saúde metabólica, composição
              corporal e longevidade, e produz conteúdo de educação em saúde nas redes sociais e no
              YouTube, onde mais de 200 mil pessoas o acompanham.
            </p>
          </div>
        </div>
      </section>

      {/* trajetoria — Figma 130:35 */}
      <section className="trajetoria">
        <div className="container">
          <div className="secao-titulo">
            <p className="sobretitulo">TRAJETÓRIA</p>
            <h2>Do diploma ao método próprio</h2>
          </div>
          <ol className="marcos">
            {marcos.map((m) => (
              <li className="marco" key={m.sigla}>
                <p className="marco-sigla">{m.sigla}</p>
                <div className="marco-texto">
                  <h3>{m.titulo}</h3>
                  <p>{m.texto}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* registros-e-sociedades — Figma 141:9 */}
      <section className="registros">
        <div className="container">
          <div className="secao-titulo secao-titulo-curto">
            <p className="sobretitulo">REGISTROS</p>
            <h2>Conheça todas as formações e especialidades</h2>
          </div>
          {registros.map((r) => (
            <div key={r.grupo}>
              <h3 className="registros-grupo">{r.grupo}</h3>
              <dl className="registros-lista">
                {r.linhas.map((l) => (
                  <div className="registros-linha" key={l.sigla}>
                    <dt>{l.sigla}</dt>
                    <dd>{l.texto}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </section>

      {/* na-midia — Figma 131:2 */}
      <section className="na-midia">
        <div className="container">
          <p className="sobretitulo">NA MÍDIA</p>
          <h2>Onde você já viu o Dr. Thiago</h2>
          <p className="na-midia-chamada">
            Entrevistas e reportagens sobre emagrecimento, alimentação, atividade física e saúde.
          </p>

          <div className="videos">
            {participacoesEmVideo.map((video) => (
              <a className="video-midia" href={video.url} key={video.url}>
                <span className="video-midia-capa">
                  <img
                    className="video-midia-imagem"
                    src={video.imagem}
                    alt={video.alt}
                    width={720}
                    height={405}
                    loading="lazy"
                  />
                  <img className="video-midia-play" src="/icones/play.svg" width={56} height={56} alt="" loading="lazy" />
                </span>
                <span className="video-midia-texto">
                  <span className="materia-veiculo">{video.veiculo}</span>
                  <strong>{video.titulo}</strong>
                  <span className="materia-link">{video.link}</span>
                </span>
              </a>
            ))}
          </div>

          <div className="materias">
            {materias.map((m) => (
              <article className="materia" key={m.url}>
                <div className="materia-logo">
                  <img src={m.logo} alt={`Logo ${m.veiculo}`} width={132} height={40} loading="lazy" />
                </div>
                <h3>{m.titulo}</h3>
                <a className="materia-link" href={m.url}>
                  Ler a matéria →
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* citacao-cta — Figma 131:26 */}
      <section className="citacao-cta">
        <div className="container citacao-inner">
          <h2 className="sr-only">Onde o Dr. Thiago atende</h2>
          <blockquote className="citacao">
            <p>
              «Nosso objetivo não é acrescentar anos à vida. É construir saúde para que exista{" "}
              <em>vida nos anos.</em>»
            </p>
          </blockquote>

          <CardsAtendimento />
        </div>
      </section>
    </div>
  );
}
